import { gql } from '@apollo/client'
import { OCCUPANCY_TO_USE_TENANT_FRAGMENT } from 'src/pages/Inbox/components/InboxBody/components/hooks/data/fragments'
//TODO maybe break into separate queries and get on their components
export const GET_PERSON = gql`
  query GetPersonInfoPanel($id: Int!) {
    person(id: $id) {
      id
      birthday
      type
      role
      created_at
      updated_at
      unit_occupancy_tenants {
        ...occupancyToUseTenantFields
        pms_id
        unit_occupancy {
          id
          pms_id
          status
          lease_from
          lease_to
          rent
          deposit
          current_balance
          move_in
          move_out
          is_active
          lease_signed
          last_payment
          last_payment_id
          current_lease
          current_lease_url
          monthly_charges
          is_eviction
          is_collections
          is_cert_funds_only
          allow_online_payment
          require_payment_full
          eligible_renewal
          deleted
          unit_occupancy_scores {
            id
            score
            score_type
            score_source
            created_at
            updated_at
          }
          unit {
            id
            pms_id
            name
            description
            bed
            bathroom
          }
          property {
            id
            pms_id
            name
            street_address
            city
            state
            zip
            is_pay_ready
          }
          pay_ready_unit_occupancy_xref {
            id
            pay_ready_lease_id
          }
          unit_occupancy_tenants {
            id
            pms_id
            is_active
            deleted
            move_out_date
            person {
              id
              first_name
              last_name
            }
          }
        }
      }
      account_integration {
        id
        isActive
        metadata
        integration {
          id
          description
        }
      }
      sticky_number {
        id
        phone_number
        property {
          id
          name
        }
      }
      person_properties {
        id
        property {
          id
          name
        }
      }
      emails {
        id
        is_default
        address
      }
      phones {
        id
        is_default
        phone_number
      }
      person_xref_data {
        id
        pay_ready_tenant_id
        pay_ready_lease_id
      }
    }
  }
  ${OCCUPANCY_TO_USE_TENANT_FRAGMENT}
`
